import { Button, Result } from 'antd';
import { Link } from 'react-router-dom';
<style></style>
export default function PageNotFound (){

 return(
    <Result
    status="404"
    title="404"
    subTitle="Sorry, the page you visited does not exist."
    extra={<Button type="primary"><Link to="/" style={{color:"white",textDecoration:"none"}}>Back Home</Link></Button>}
  />


)
}

